import { render, staticRenderFns } from "./CumulativeValue.vue?vue&type=template&id=38183f72&scoped=true&"
import script from "./CumulativeValue.vue?vue&type=script&lang=js&"
export * from "./CumulativeValue.vue?vue&type=script&lang=js&"
import style0 from "./CumulativeValue.vue?vue&type=style&index=0&id=38183f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38183f72",
  null
  
)

export default component.exports